<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<h2>{{maContent.ma8_1_1}}</h2>
			<p>{{maContent.ma8_1_2}}</p>
			<div>
				// image ///
			</div>
			<button class="btn" @click="goToMyAccount">My account</button>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		props : ['totalArea', 'areaIdArray'],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'QuoteRequestedSuccessModal',
							
			}
		},
		
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			},
			maContent(){
				return this.$store.getters.getBuildData;
				},
		},
		methods : {
			
		},

		created(){
			this.$store.dispatch('setIsWaiting', {isWaiting : false, message : ''});
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/QuoteRequestedSuccessModal.vue